import { updateVar } from '@ps/api/editor/file'
import { getIframe } from '@ps/bridge/iframe/iframe'
import { IframeWindow } from '../../iframe/iframe.window.type'

const scripts: {
  [key: string]: boolean;
} = {}

/**
 * 添加脚本
 * @param scripts 脚本列表
 * @param src 脚本名字
 * @param id 项目id
 */
const addScript = async({ scripts, src, id }: {
  scripts: string[];
  src: string;
  id: number;
}) => {
  const qiciScripts = scripts
  if (qiciScripts.indexOf(src) === -1) {
    qiciScripts.push(src)
    try {
      await updateVar({
        params: {
          pid: id,
          name: 'scripts'
        },
        data: JSON.stringify(qiciScripts)
      })
      return true
    } catch (err) {
      return false
    }
  } else {
    return true
  }
}

/**
 * 移除脚本
 * @param scripts 脚本列表
 * @param src 脚本名字
 * @param id 项目id
 */
const removeScript = async({ scripts, src, id }: {
  scripts: string[];
  src: string;
  id: number;
}) => {
  const qiciScripts = scripts.filter(item => item !== src)
  try {
    await updateVar({
      params: {
        pid: id,
        name: 'scripts'
      },
      data: JSON.stringify(qiciScripts)
    })
    return true
  } catch (err) {
    return false
  }
}

/**
 * 资源管理模块
 */
export default {
  load({ id, reload = false, src }: { id: number; reload?: boolean; src: string }) {
    return new Promise(function(resolve, reject) {
      const gameWindow: IframeWindow = getIframe()

      if (!getIframe()) {
        reject(new Error('游戏未初始化成功'))
        return
      }

      const doc: Document = gameWindow.document
      const body = doc.body

      const hasEle = Boolean(doc.querySelector(`script[src='${src}']`))
      // 加载过、有脚本script标签、且不需要重新reload，则直接返回
      if (scripts[src] && hasEle && !reload) {
        resolve(true)
        return
      }

      // 是否需要重新加载
      if (reload) {
        const scriptElement = doc.querySelector(`script[src='${src}']`)
        if (scriptElement) {
          body.removeChild(scriptElement)
          scripts[src] = false
        }
      }

      const ele = doc.createElement('script')
      ele.setAttribute('type', 'text/javascript')
      ele.src = src
      ele.onload = async function() {
        const res = await addScript({
          scripts: gameWindow.qici.scripts,
          src,
          id
        })
        if (res) {
          scripts[src] = true
          resolve(true)
        } else {
          reject(new Error(`加载${src}失败`))
          body.removeChild(ele)
        }
      }
      ele.onerror = function() {
        reject(new Error(`加载${src}失败`))
        body.removeChild(ele)
      }
      body.appendChild(ele)
    })
  },

  async remove({ id, src }: {id: number; src: string}) {
    const gameWindow: IframeWindow = getIframe()

    if (
      gameWindow
    ) {
      const scriptElement = document.querySelector(`script[src='${src}']`)
      if (scriptElement) {
        gameWindow.document.body.removeChild(scriptElement)
        scripts[src] = false
        const res = await removeScript({
          scripts: gameWindow.qici.scripts,
          src,
          id
        })
        if (res) {
          return true
        }
        return false
      }
    }
    return false
  }
}
